import type {
  OAuthLoginData,
  PersistedLoginData,
  WalletBalanceData,
} from "@/betby/api/types";

type AuthCurrencyMode = "gc" | "sc";

export interface LoginSuccessPayload {
  accessToken: string;
  refreshToken: string;
  expiresTime: number | null;
  userId: number | null;
  productId: number | null;
  businessId: number | null;
  loginData: PersistedLoginData;
  userInfo: Record<string, unknown> | null;
  currencyMode: AuthCurrencyMode | null;
}

export function isValidLoginResponse(
  data: OAuthLoginData | null | undefined,
): data is OAuthLoginData {
  return !!data?.access_token && !!data?.refresh_token;
}

export function buildLoginSuccessPayload(
  data: OAuthLoginData,
): LoginSuccessPayload {
  const userInfo = (data.userinfo ?? data.account_info ?? null) as Record<
    string,
    unknown
  > | null;
  const gameCurrencyAlias =
    typeof userInfo?.game_currency_alias === "string"
      ? userInfo.game_currency_alias.toLowerCase()
      : null;
  const currencyMode =
    gameCurrencyAlias === "gc" || gameCurrencyAlias === "sc"
      ? gameCurrencyAlias
      : null;

  return {
    accessToken: String(data.access_token),
    refreshToken: String(data.refresh_token),
    expiresTime:
      typeof data.expires_time === "number" ? data.expires_time : null,
    userId: data.user_id != null ? Number(data.user_id) : null,
    productId: data.product_id != null ? Number(data.product_id) : null,
    businessId: data.business_id != null ? Number(data.business_id) : null,
    loginData: {
      userinfo: data.userinfo ?? null,
      account_info: data.account_info ?? null,
      connection_info: data.connection_info ?? null,
      basic: data.basic ?? null,
    },
    userInfo,
    currencyMode,
  };
}

export function extractWalletBalances(
  data: WalletBalanceData | null | undefined,
): {
  gc: number;
  sc: number;
} | null {
  if (!data?.wallet_info_usd) {
    return null;
  }

  return {
    sc: data.wallet_info_usd.cash ?? 0,
    gc: data.wallet_info_usd.coin ?? 0,
  };
}
